<template>
  <v-dialog v-model="show" max-width="1180" class="elevation-0" persistent>
    <v-card
      rounded="0"
      width="1180"
      class="auth-modal-card"
      :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'"
    >
      <v-btn
        icon
        @click="$emit('close')"
        style="position: absolute; top: 8px; right: 8px; z-index: 10; background: #039de9;"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>

      <v-row class="pa-0 pa-md-6" align="center" justify="center">
        <!-- Wheel Section -->
        <v-col cols="12" lg="8" class="text-center">
          <div class="bg-wrapper">
            <div class="wrapper-box" id="wheel">
              <span class="dot-one">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-three">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-four">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-five">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <!-- Start Conditional Running For First Modal -->
              <span class="dot-six" v-if="!isFirstModal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-seven" v-if="!isFirstModal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <!-- End Conditional Running For First Modal -->

              <!-- Start Conditional Running For Second Modal -->
              <span class="dot-seventeen" v-if="isFirstModal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_62_3261)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_62_3261"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-eightteen" v-if="isFirstModal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_62_3258)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_62_3258"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <!-- End Conditional Running For Second Modal -->

              <span class="dot-eight">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-nine">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-ten">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-eleven">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-twelve">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-thirteen">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-fourteen">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-fifteen">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.49749 0.721393C10.9803 -0.479765 15.588 2.18052 16.7892 6.6633C17.9903 11.1461 15.3301 15.7538 10.8473 16.955C6.36448 18.1562 1.75674 15.4959 0.555579 11.0131C-0.64558 6.5303 2.0147 1.92255 6.49749 0.721393Z"
                    fill="url(#paint0_radial_54_760)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_760"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.67238 8.83819) rotate(-15) scale(8.40313)"
                    >
                      <stop stop-color="#FFB800" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span class="dot-sixteen">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.51872 1.44056C8.53788 -0.879896 13.6772 0.497168 15.9976 4.51632C18.3181 8.53548 16.941 13.6748 12.9219 15.9952C8.9027 18.3157 3.76343 16.9386 1.44297 12.9195C-0.877495 8.9003 0.49957 3.76103 4.51872 1.44056Z"
                    fill="url(#paint0_radial_54_763)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_54_763"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.72029 8.71789) rotate(-30) scale(8.40313)"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <div v-if="!isFirstModal">
                <button id="spin" @click="startSpin">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="85"
                    height="85"
                    viewBox="0 0 85 85"
                    fill="none"
                    class="border-gradient"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M42.3985 79.0943C62.5091 79.0943 78.812 62.7913 78.812 42.6807C78.812 22.57 62.5091 6.26713 42.3985 6.26713C22.2878 6.26713 5.9849 22.57 5.9849 42.6807C5.9849 62.7913 22.2878 79.0943 42.3985 79.0943ZM42.3985 84.6963C65.6031 84.6963 84.4141 65.8853 84.4141 42.6807C84.4141 19.4761 65.6031 0.665039 42.3985 0.665039C19.1939 0.665039 0.382812 19.4761 0.382812 42.6807C0.382812 65.8853 19.1939 84.6963 42.3985 84.6963Z"
                      fill="url(#paint0_linear_54_730)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_54_730"
                        x1="0.382811"
                        y1="26.6737"
                        x2="83.1548"
                        y2="20.5642"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#9D4B00" />
                        <stop offset="0.505" stop-color="#FFB800" />
                        <stop offset="1" stop-color="#9B4C03" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="17"
                    viewBox="0 0 50 17"
                    fill="none"
                    class="spin-text"
                  >
                    <path
                      d="M38.1133 0.378418H41.9199L46.4072 9.85715L46.1551 0.378418H49.281H49.5079V0.655721C49.4239 0.756559 49.3651 0.8658 49.3315 0.983444C49.3147 1.10109 49.3063 1.30276 49.3063 1.58847V16.0839H45.8274L41.2645 5.9749V16.0839H38.1133V0.378418Z"
                      fill="url(#paint0_linear_54_731)"
                    />
                    <path
                      d="M26.3906 16.0839V13.2352H29.441V3.22708H26.5419V0.378418H35.8189V3.22708H32.7686V13.2352H35.945V16.0839H26.3906Z"
                      fill="url(#paint1_linear_54_731)"
                    />
                    <path
                      d="M13.2031 16.0839V0.378418H18.7744C20.0181 0.378418 21.0516 0.5969 21.8752 1.03386C22.6987 1.45402 23.3121 2.02543 23.7154 2.7481C24.1188 3.45396 24.3205 4.23545 24.3205 5.09257C24.3205 5.73121 24.2028 6.33624 23.9675 6.90765C23.7491 7.46226 23.4129 7.94964 22.9592 8.36979C22.5222 8.78995 21.9592 9.12608 21.2701 9.37817C20.5979 9.61346 19.808 9.7311 18.9004 9.7311H16.8333V16.0839H13.2031ZM16.8333 6.83202H18.6988C19.0853 6.83202 19.4214 6.75639 19.7071 6.60514C20.0097 6.45388 20.2449 6.2438 20.413 5.9749C20.5811 5.706 20.6651 5.40349 20.6651 5.06737C20.6651 4.71443 20.5811 4.41192 20.413 4.15983C20.2449 3.90773 20.0181 3.71446 19.7324 3.58001C19.4466 3.44556 19.1105 3.37834 18.724 3.37834H16.8333V6.83202Z"
                      fill="url(#paint2_linear_54_731)"
                    />
                    <path
                      d="M5.6171 16.3862C4.55831 16.3862 3.53313 16.2433 2.54156 15.9576C1.56679 15.6551 0.7769 15.1929 0.171875 14.5711L1.88611 11.7224L2.01216 11.5207L2.26425 11.672C2.29787 11.7896 2.33988 11.9157 2.3903 12.0501C2.45753 12.1678 2.60038 12.319 2.81886 12.5039C3.22221 12.7728 3.65917 12.9997 4.12975 13.1846C4.60032 13.3694 5.08771 13.4703 5.59189 13.4871C5.94483 13.4871 6.25574 13.4619 6.52464 13.4115C6.81035 13.361 7.05404 13.277 7.25571 13.1594C7.45739 13.0417 7.60865 12.8821 7.70948 12.6804C7.82713 12.4619 7.88595 12.2014 7.88595 11.8989C7.88595 11.7476 7.86074 11.5964 7.81032 11.4451C7.77671 11.2771 7.70948 11.1174 7.60865 10.9661C7.50781 10.7981 7.34815 10.63 7.12967 10.462C6.92799 10.2939 6.66749 10.109 6.34818 9.90735C6.02886 9.70567 5.62551 9.49559 5.13812 9.27711C4.06252 8.75612 3.2054 8.26033 2.56677 7.78976C1.94494 7.31918 1.49117 6.80659 1.20546 6.25198C0.93656 5.68057 0.80211 4.99992 0.80211 4.21002C0.80211 3.43694 1.02899 2.73948 1.48276 2.11765C1.95334 1.49581 2.58357 1.00003 3.37347 0.630291C4.16336 0.260553 5.02888 0.0756836 5.97004 0.0756836C6.6927 0.0756836 7.34815 0.151312 7.93637 0.302568C8.54139 0.453825 9.096 0.680709 9.60019 0.983222C10.1212 1.28573 10.6002 1.67228 11.0371 2.14285L8.89432 4.46212L8.74307 4.63858L8.51618 4.43691C8.49938 4.30246 8.47417 4.17641 8.44056 4.05877C8.40694 3.92432 8.2977 3.75626 8.11283 3.55458C7.84393 3.31929 7.55823 3.16804 7.25571 3.10081C6.9532 3.01678 6.60027 2.97476 6.19692 2.97476C5.91121 2.97476 5.65072 3.00838 5.41543 3.0756C5.18014 3.12602 4.97847 3.21005 4.8104 3.32769C4.64234 3.42853 4.50789 3.54618 4.40705 3.68063C4.32302 3.81508 4.28101 3.95793 4.28101 4.10919C4.28101 4.26044 4.29781 4.4033 4.33142 4.53775C4.36504 4.65539 4.43226 4.78144 4.5331 4.91589C4.63394 5.05034 4.78519 5.19319 4.98687 5.34445C5.20535 5.4957 5.48265 5.67217 5.81878 5.87384C6.17171 6.05871 6.60867 6.27719 7.12967 6.52929C7.93637 6.93264 8.61702 7.31918 9.17163 7.68892C9.72623 8.05866 10.1632 8.4452 10.4825 8.84855C10.8186 9.2351 11.0539 9.66366 11.1884 10.1342C11.3396 10.6048 11.4153 11.1426 11.4153 11.7476C11.4153 12.5375 11.2136 13.2854 10.8102 13.9913C10.4069 14.6971 9.77665 15.2769 8.91953 15.7307C8.06241 16.1677 6.9616 16.3862 5.6171 16.3862Z"
                      fill="url(#paint3_linear_54_731)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_54_731"
                        x1="-0.406662"
                        y1="1.91161"
                        x2="48.5692"
                        y2="-4.93785"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#FD8A20" />
                        <stop offset="0.505" stop-color="#FFD25F" />
                        <stop offset="1" stop-color="#EE7E16" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_54_731"
                        x1="-0.406958"
                        y1="1.91161"
                        x2="48.5689"
                        y2="-4.93785"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#FD8A20" />
                        <stop offset="0.505" stop-color="#FFD25F" />
                        <stop offset="1" stop-color="#EE7E16" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_54_731"
                        x1="-0.409946"
                        y1="1.91161"
                        x2="48.5659"
                        y2="-4.93785"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#FD8A20" />
                        <stop offset="0.505" stop-color="#FFD25F" />
                        <stop offset="1" stop-color="#EE7E16" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_54_731"
                        x1="-0.407944"
                        y1="1.9114"
                        x2="48.5679"
                        y2="-4.93807"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#FD8A20" />
                        <stop offset="0.505" stop-color="#FFD25F" />
                        <stop offset="1" stop-color="#EE7E16" />
                      </linearGradient>
                    </defs>
                  </svg>
                </button>
              </div>

              <div v-if="isFirstModal">
                <button id="spin3">
                  <span v-if="!isThirdModal">{{ selectedBonus }}%</span>

                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="198"
                    height="198"
                    viewBox="0 0 198 198"
                    fill="none"
                  >
                    <path
                      d="M165 49.5L74.25 140.25L33 99"
                      stroke="#59CA00"
                      stroke-width="20"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="44"
                viewBox="0 0 29 44"
                fill="none"
                class="arrow-icon"
              >
                <defs>
                  <linearGradient
                    id="paint0_linear_54_774"
                    x1="0.394531"
                    y1="13.5066"
                    x2="28.0715"
                    y2="12.1755"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#9D4B00" />
                    <stop offset="0.505" stop-color="#FFB800" />
                    <stop offset="1" stop-color="#9B4C03" />
                  </linearGradient>
                </defs>
              </svg>

              
              <!-- Start Conditional Running For First Modal -->
              <div class="container-box" v-if="!isFirstModal">
                <div v-for="(cls, idx) in wedgeClasses" :key="cls" :class="cls">
                  <span>{{ generatedValues[idx] !== undefined ? generatedValues[idx] + '%' : '%' }}</span>
                </div>
              </div>
              <div class="container-box" v-if="isFirstModal">
                <div class="result"><span>{{ selectedBonus }}%</span></div>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Content Section -->
        <v-col cols="12" lg="4" class="wheel-content text-center text-lg-left">
          <div v-if="!isFirstModal">
            <!-- Start Conditional Running For First Modal -->
            <h2>Spin To Get Tradable Bonus</h2>
            <p>
              By using this spin, you’ll receive a tradable bonus on your first deposit. Once your spin result is determined, a tradable bonus account will be created automatically. Your first deposit into this account will grant you a bonus based on your spin outcome.
            </p>
            <v-btn
              tile
              elevation="0"
              class="ma-0 text-capitalize btn-account"
              color="greenMain"
              @click="startSpin"
            >
              Click to Spin
            </v-btn>
            <!-- Start Conditional Running For First Modal -->
          </div>

          

          <!-- Start Conditional Running For Second Modal -->
          <div v-if="isFirstModal && !isThirdModal">
            <h2>Congratulations</h2>
            <p>
              You Have Got {{ selectedBonus }}% Deposit Bonus.Your New Tradable Bonus Account Created Successfully.You Will get your Tradable Bonus For Your First Deposit. To Collect This Bonus, Please Deposit Your new Tradable Bonus Account.Please Check Your Email For Account Information.
            </p>
            <v-btn
              tile
              elevation="0"
              class="ma-0 text-capitalize btn-account"
              color="greenMain"
              @click="isThirdModal = true"
            >
              Ok
            </v-btn>
          </div>
          <!-- End Conditional Running For Second Modal -->

          <!-- Start Conditional Running For Third Modal -->
          <div v-if="isFirstModal && isThirdModal">
            <h2>Done</h2>
            <p>
              Thank You For Choosing Tradable Bonus Spin.
            </p>
            <v-btn
              tile
              elevation="0"
              class="ma-0 text-capitalize btn-account"
              color="greenMain"
              @click="$emit('close')"
            >
              Close
            </v-btn>
          </div>
          <!-- End Conditional Running For Third Modal -->
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "SpinWheelDialog",
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      minSpin: {
        type: Number,
        default: 0,
      },
      maxSpin: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        isFirstModal: false,
        isThirdModal: false,
        selectedBonus: null,
        generatedValues: [],
        wedgeClasses: ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight']
      };
    },
    mounted() {
      this.generateSpinValues();
    },
    watch: {
      minSpin() {
        this.generateSpinValues();
      },
      maxSpin() {
        this.generateSpinValues();
      }
    },
    methods: {
      generateSpinValues() {
        const values = new Set();
        const range = this.maxSpin - this.minSpin + 1;
        
        if (range < 8) {
          // If the range is less than 8, just fill with all values possible
          for (let i = this.minSpin; i <= this.maxSpin; i++) {
            values.add(i);
          }
        } else {
          // Otherwise, generate unique random values
          while (values.size < 8) {
            const rand = Math.floor(Math.random() * range) + this.minSpin;
            values.add(rand);
          }
        }
        this.generatedValues = Array.from(values);
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async startSpin() {
        if (!this.generatedValues.length) {
          this.generateSpinValues();
        }
        const randomIndex = Math.floor(Math.random() * this.generatedValues.length);
        const selectedBonus = this.generatedValues[randomIndex];
        this.selectedBonus = selectedBonus;

        const wheel = document.getElementById("wheel");
        if (wheel) {
          wheel.classList.add("spinning");

          setTimeout(async () => {
            wheel.classList.remove("spinning");
            this.isFirstModal = true;
            this.isThirdModal = false;
            console.log("Selected Bonus 1:", selectedBonus);
            await this.sleep(5000);
            this.$emit("finished", selectedBonus);
          }, 2000);
        } else {
          this.isFirstModal = true;
          this.isThirdModal = false;
          await this.sleep(5000);
          this.$emit("finished", selectedBonus);
        }
      }
    },
  };
</script>
<style scoped>
@keyframes rotateWheel {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1440deg); /* 4 full spins */
  }
}

.spinning {
  animation: rotateWheel 2s ease-out;
}
</style>
